// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3v15K","ranges":"BmiRanges_ranges__1MGrg"};